export default __webpack_public_path__ + "static/media/date-concept.7a5382e3.svg";